let $ = require("jquery");

// Данный файл - лишь собрание подключений готовых компонентов.
// Рекомендуется создавать отдельный файл в папке components и подключать все там

// Определение операционной системы на мобильных
// import {mobileCheck} from "./functions/mobile-check";
//
// console.log(mobileCheck())

// Определение ширины экрана
// import { isMobile, isTablet, isDesktop } from './functions/check-viewport';
// if (isDesktop()) {
//   console.log('...')
// }

// Троттлинг функции (для ресайза, ввода в инпут, скролла и т.д.)
// import { throttle } from './functions/throttle';
// let yourFunc = () => { console.log('throttle') };
// let func = throttle(yourFunc);
// window.addEventListener('resize', func);

// Фикс фулскрин-блоков
// import './functions/fix-fullheight';

// Реализация бургер-меню
// import { burger } from './functions/burger';

// Реализация остановки скролла (не забудьте вызвать функцию)
// import { disableScroll } from './functions/disable-scroll';

// Реализация включения скролла (не забудьте вызвать функцию)
// import { enableScroll } from './functions/disable-scroll';

// Реализация модального окна
// import GraphModal from 'graph-modal';
// const modal = new GraphModal();

// Реализация табов
// import GraphTabs from 'graph-tabs';
// const tabs = new GraphTabs('tab');

// Получение высоты шапки сайта (не забудьте вызвать функцию)
// import { getHeaderHeight } from './functions/header-height';

// Подключение плагина кастом-скролла
// import 'simplebar';

// Подключение плагина для позиционирования тултипов
// import { createPopper, right} from '@popperjs/core';
// createPopper(el, tooltip, {
//   placement: 'right'
// });

// Подключение свайпера
import Swiper, {Navigation, Pagination} from 'swiper';

Swiper.use([Navigation, Pagination]);


// Подключение анимаций по скроллу
// import AOS from 'aos';
// AOS.init();

// Подключение параллакса блоков при скролле
// import Rellax from 'rellax';
// const rellax = new Rellax('.rellax');

// Подключение плавной прокрутки к якорям
// import SmoothScroll from 'smooth-scroll';
// const scroll = new SmoothScroll('a[href*="#"]');

// Подключение событий свайпа на мобильных
// import 'swiped-events';
// document.addEventListener('swiped', function(e) {
//   console.log(e.target);
//   console.log(e.detail);
//   console.log(e.detail.dir);
// });

// import { validateForms } from './functions/validate-forms';
// const rules1 = [...];

// const afterForm = () => {
//   console.log('Произошла отправка, тут можно писать любые действия');
// };

// validateForms('.form-1', rules1, afterForm);
// Подключаем Fancybox
import {Fancybox, Carousel, Panzoom} from "@fancyapps/ui";


document.addEventListener('DOMContentLoaded', function () {
  const heroSlider = new Swiper(".hero-slider", {
    // autoplay: {
    //   delay: 2500,
    //   disableOnInteraction: false,
    // },
    speed: 1500,
    navigation: {
      nextEl: ".hero-button-next",
      prevEl: ".hero-button-prev",
    },
    pagination: {
      el: ".hero-pagination",
      clickable: true,
    },
    grabCursor: true,
    mousewheel: true,
    keyboard: true,
  });


  const burger = document.querySelector('.burger'),
    nav = document.querySelector('.header__nav'),
    overlay = document.querySelector('.overlay'),
    body = document.querySelector('.page__body'),
    searchBtn = document.querySelector('.header__search'),
    search = document.querySelector('.search'),
    searchClose = document.querySelector('.search__close');


  burger.addEventListener('click', () => {
    burger.classList.toggle('burger--active');
    nav.classList.toggle('header__nav--open');
    overlay.classList.toggle('active');
    body.classList.toggle('fixed');
  })

  overlay.addEventListener('click', () => {
    burger.classList.remove('burger--active');
    nav.classList.remove('header__nav--open');
    overlay.classList.remove('active');
    body.classList.remove('fixed');
    search.classList.remove('search--open');
  })

  searchBtn.addEventListener('click', () => {
    search.classList.toggle('search--open');
    overlay.classList.toggle('active');
  })
  searchClose.addEventListener('click', () => {
    search.classList.remove('search--open');
    overlay.classList.remove('active');
  })

  // Сайдбар

  const sidebarItems = $('.sidebar__link--drop'),
    sidebarItemCurrent = $('.sidebar__link--current.sidebar__link--drop');
  if (sidebarItemCurrent.length !== 0) {
    sidebarItemCurrent.siblings('.sidebar__drop').addClass('sidebar__drop--open');
    sidebarItemCurrent.toggleClass('sidebar__link--drop-active');
  } else {
    sidebarItems.first().toggleClass('sidebar__link--drop-active');
    sidebarItems.first().siblings('.sidebar__drop').addClass('sidebar__drop--open');
  }

  sidebarItems.on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('sidebar__link--drop-active')
    $(this).siblings('.sidebar__drop').slideToggle();
    console.log($(this))
  });

});
